export default __webpack_public_path__ + "static/media/icon4.65aa8bc7.svg";